import { gql, useMutation } from "@apollo/client";

const CREATE_ADMIN_USER_MUTATION = gql`
  mutation CreateAdminUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $role: AdminRole!
    $permissions: [AdminPermission!]!
  ) {
    createAdminUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      role: $role
      permissions: $permissions
    ) {
      _id
      firstName
      lastName
      email
      role
      permissions
      isActive
      createdAt
    }
  }
`;

export const useCreateAdminUserMutation = () => {
  const [createAdminUserMutation, { loading, error, data }] = useMutation(
    CREATE_ADMIN_USER_MUTATION,
    {
      refetchQueries: ['GetAllAdminUsers'],
      awaitRefetchQueries: true,
    }
  );

  const createAdminUser = async (variables: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    role: string;
    permissions: string[];
  }) => {
    try {
      const { data } = await createAdminUserMutation({
        variables,
      });
      return data?.createAdminUser;
    } catch (error) {
      console.error("Error creating admin user:", error);
      throw error;
    }
  };

  return { createAdminUser, loading, error, data };
};






























